import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es7.promise.finally";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { userItemsPerListMixin } from '../../../utils/vuex';
import moment from 'moment';
import { mapState } from 'vuex';
import get from 'lodash/get';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreConnectorsList',
  mixins: [userItemsPerListMixin],
  props: {
    accounts: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    tenants: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      cmOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      },
      tableOptions: defaultTableOptions,
      isLoadingConnectors: false,
      searchItem: '',
      connectorDialog: false,
      editConnectorIndex: -1,
      deleteDialog: false,
      deleteBridgeId: null,
      newBridgeType: null,
      bridgeTypes: [],
      bridges: [],
      bridgeValidations: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('Connectors.Connectors.tableHeaders.id'),
          value: 'id',
          align: 'right'
        }, {
          text: this.$i18n_t('Connectors.Connectors.tableHeaders.state'),
          value: 'state'
        }, {
          text: this.$i18n_t('Connectors.Connectors.tableHeaders.name'),
          value: 'name'
        }, {
          text: this.$i18n_t('Connectors.Connectors.tableHeaders.type'),
          value: 'type'
        }, {
          text: this.$i18n_t('Connectors.Connectors.tableHeaders.kind'),
          value: 'table.kind',
          align: 'center'
        }, {
          text: this.$i18n_t('Connectors.Connectors.tableHeaders.account'),
          value: 'tenantId'
        }, {
          text: this.$i18n_t('Connectors.Connectors.tableHeaders.createdAt'),
          value: 'createdAt'
        }, {
          text: '',
          value: '',
          align: 'end',
          sortable: false,
          width: '78'
        }],
        footer: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    },
    runtimeInstance: function runtimeInstance() {
      return this;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasNoConnectors: function hasNoConnectors() {
      return this.bridges.length === 0;
    },
    tableBridges: function tableBridges() {
      var _this = this;

      return this.bridges.map(function (bridge) {
        var config = _this.bridgeConfig(bridge);

        var inbound = get(config, 'manifest.functionScope.invokeDirection.inbound');
        var outbound = get(config, 'manifest.functionScope.invokeDirection.outbound');
        return _objectSpread(_objectSpread({}, bridge), {}, {
          table: {
            kind: inbound && outbound ? 'both' : inbound ? 'inbound' : 'outbound'
          }
        });
      });
    }
  }),
  watch: {
    tenants: function tenants() {
      this.loadData();
    }
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    get: get,
    showCreateDialog: function showCreateDialog() {
      this.$emit('create');
    },
    handleDeleteConnector: function handleDeleteConnector(id) {
      this.deleteDialog = false;
      this.deleteBridge(id);
    },
    loadData: function loadData() {
      var _this2 = this;

      this.isLoadingConnectors = true;
      this.bridgeTypes = [];
      this.bridges = [];
      return Promise.all([this.loadBridgeTypes(), this.loadBridgeConfigs()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            types = _ref2[0],
            configs = _ref2[1];

        _this2.bridgeTypes = types.map(function (type) {
          return _objectSpread(_objectSpread({}, type), {}, {
            name: get(type, 'manifest.displayName')
          });
        }).sort(function (b1, b2) {
          if (b1.name > b2.name) {
            return 1;
          }

          if (b1.name < b2.name) {
            return -1;
          }

          return 0;
        });
        _this2.bridges = configs.map(function (config) {
          var bridgeType = _this2.bridgeTypes.find(function (t) {
            return t.type === config.type;
          });

          config.displayName = bridgeType ? get(bridgeType, 'manifest.displayName') : '';
          return config;
        });
      }).finally(function () {
        _this2.isLoadingConnectors = false;
      });
    },
    bridgeConfigIsInbound: function bridgeConfigIsInbound(bridge) {
      return get(bridge, 'manifest.functionScope.invokeDirection.inbound', false);
    },
    bridgeConfigIsOutbound: function bridgeConfigIsOutbound(bridge) {
      return get(bridge, 'manifest.functionScope.invokeDirection.outbound', false);
    },
    bridgeConfig: function bridgeConfig(bridge) {
      var foundMatch = this.bridgeTypes.find(function (config) {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    bridgeConfigKeys: function bridgeConfigKeys(instance) {
      var bridgeManifest = this.bridgeConfig(instance).manifest;
      var keys = Object.keys(bridgeManifest.config[0]).filter(function (key) {
        if (get(bridgeManifest, "config[0][".concat(key, "].hidden"))) {
          return false;
        } // if field is readonly, only show if it has a value


        if (get(bridgeManifest, "config[0][".concat(key, "].readonly"))) {
          return !!instance.bridge.config[key];
        }

        var visibleConfig = get(bridgeManifest, "config[0][".concat(key, "].visible")) || {};
        return Object.keys(visibleConfig).every(function (dependentKey) {
          return instance.bridge.config[dependentKey] === visibleConfig[dependentKey];
        });
      });
      return keys.sort(function (a, b) {
        var orderIdxA = get(bridgeManifest, "config[0][".concat(a, "].orderIdx")) || 0;
        var orderIdxB = get(bridgeManifest, "config[0][".concat(b, "].orderIdx")) || 0;

        if (orderIdxA < orderIdxB) {
          return -1;
        }

        if (orderIdxA > orderIdxB) {
          return 1;
        }

        return a.localeCompare(b);
      });
    },
    loadBridgeTypes: function loadBridgeTypes() {
      return ApiService.getBridgeTypes().then(function (bridgeTypes) {
        return bridgeTypes;
      });
    },
    loadBridgeConfigs: function loadBridgeConfigs() {
      if (!this.tenants) {
        this.tenants = [];
      }

      var ids = this.tenants.map(function (acc) {
        return acc.id;
      });
      return ApiService.getBridgesForTenants(ids);
    },
    deleteBridge: function deleteBridge(id) {
      var _this3 = this;

      var bridge = this.bridges.find(function (b) {
        return b.id === id;
      });
      var deletePromise = Promise.resolve();

      if (bridge.id) {
        deletePromise = ApiService.deleteBridge(bridge.id);
      }

      deletePromise.then(function () {
        _this3.loadData();
      }).catch(function (error) {
        console.error(error);
      });
    },
    localizeDate: function localizeDate(date) {
      if (date) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(date).format('L LTS');
      }

      return '-';
    }
  }
};